import React, { useEffect } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Link from '@material-ui/core/Link'
import TextField from '@material-ui/core/TextField'
import SvgIcon from '@material-ui/core/SvgIcon'
import Typography from '@material-ui/core/Typography'
import { ReactComponent as IconSearchSubmit } from 'assets/icons/search-submit.svg'
import useStyles from './styles'
import { useHistory } from 'react-router-dom'

const Search = ({
  placeholder,
  getSearchOptions,
  clearSearchOptions,
  searchOptions,
  onSearch,
  value,
  setValue,
  noOptionsText,
  filterOptions,
}) => {
  useEffect(() => {
    return () => {
      clearSearchOptions()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleInputChange = (_, value) => {
    setValue(value)
    if (value.length >= 4) {
      getSearchOptions(value)
    } else if (!value.length) {
      clearSearchOptions()
      onSearch('')
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    onSearch(value)
  }

  const classes = useStyles()
  const history = useHistory()

  return (
    <form onSubmit={handleSubmit} className={classes.root}>
      <Autocomplete
        classes={{
          clearIndicatorDirty: classes.clearIndicator,
        }}
        className={`${classes.input} ${value ? classes.hasValue : ''}`}
        freeSolo
        fullWidth
        options={searchOptions}
        inputValue={value}
        onInputChange={handleInputChange}
        renderInput={params => (
          <TextField {...params} placeholder={placeholder} variant="outlined" />
        )}
        getOptionLabel={option =>
          option && option.name ? option.name : option
        }
        renderOption={option => {
          if (!option.name) {
            return option
          }
          if (!option.pathname) {
            return (
              <Typography variant="body2" className={classes.noLink} noWrap>
                {option.name}
              </Typography>
            )
          }
          return (
            <Link
              onClick={() =>
                history.push({ pathname: option.pathname, state: option.back })
              }
              className={classes.link}
              variant="body2"
              title={option.name}
            >
              {option.name}
            </Link>
          )
        }}
        onChange={(_, value) => {
          if (value && value.pathname) {
            history.push({ pathname: value.pathname, state: value.back })
          } else if (value && value.name) {
            onSearch(value.name)
          }
        }}
        noOptionsText={noOptionsText}
        filterOptions={filterOptions}
      />
      <IconButton
        aria-label="submit"
        className={classes.submit}
        onClick={handleSubmit}
      >
        <SvgIcon component={IconSearchSubmit} />
      </IconButton>
    </form>
  )
}
export default Search
